import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

export const slide: Slide = {
  title: "",
  description:
    "This simple case study will show how different types of absorbers mounted on the walls of a rectangular room change its reverberation time. You can switch between different types of used absorbers, observe the change in reverberation time and listen to sound examples for speech and music.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [5, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/05/principle/slide-1-image.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  formatter: "html",
                  data:
                    "<b>The case room has dimensions L x W x H = 8 x 6 x 3.5 m. Its volume is V = 168 m3.</b> <br /> According to the norm DIN18041, the target optimum reverberation time for a room of this size for speech is 0.7 s, and for music 1.2 s. The tolerance boundaries for the reverberation time are shown in the right graph for speech (in orange) and music (in navy blue).",
                },
              },
            },
          },
        ],
      ],
    },
  },
};
